export default function () {

    function getLanguagePack (lang) {
        switch(lang) {
            case 'de-de': {
                return createLanguagePackage(getGermanKey());
            }
                break;
            case 'en-gb': {
                return createLanguagePackage(getEnglishKey());
            }
                break;
            default: {
                return createLanguagePackage(getGermanKey());
            }
        }
    }

    function createLanguagePackage(translations) {
        return _.mapValues(translations, function addSuffix(value) {
            if (angular.isObject(value)) {
                return _.mapValues(value, addSuffix);
            }

            return value;
        });
    }

    function getGermanKey() {
        let translations = {
            HOME: 'Home',
            HELLO: 'Hallo',
            BUYING_SECTION_HEADER: 'Kaufen',
            SELLING_SECTION_HEADER: 'Verkaufen',
            ADMIN_SECTION_HEADER: 'Administration',
            LANGUAGE: 'Sprache',
            REGISTER: 'Registrieren',
            LOG_IN: 'Anmelden',
            PROFILE: 'Profil',
            PURCHASES: 'Käufe',
            NO_PURCHASES: 'Keine Käufe',
            DELIVERIES: 'Lieferungen',
            PAYMENTS: 'Bezahlung',
            LOG_OUT: 'Abmelden',
            SLOGAN: 'Regionale Lebensmittel',
            SEARCH: 'Suche',
            SEARCH_PLACEHOLDER: 'Suche nach Produkt oder Kategorie',
            CATEGORIES: 'Kategorien',
            OVERVIEW: 'Übersicht',
            CONTAINER_TYPES: 'Transportbehälter',
            TRUCKS: 'Lieferwagen',
            PRODUCTS: 'Produkte',
            USER: 'Benutzer',
            USERS: 'Benutzer',
            FILES: 'Dateien',
            PAGES: 'Seiten',
            ARTICLES: 'Artikel',
            PAGE: 'Seite',
            LINK: 'Link',
            FILE: 'Datei',
            ITEMS: 'Einheiten',
            SHOPPING_CARTS: 'Einkaufswagen',
            DELETE_ITEM: 'Einheit entfernen',
            SURE_TO_DELETE: 'Sind Sie sicher, dass Sie diese Einheit entfernen möchten?',
            CANCEL: 'Abbrechen',
            CHANGE_PASSWORD: '[NT]',
            DELETE: 'Entfernen',
            GO: 'Los',
            LOGIN: 'Anmelden',
            TITLE_WTF: 'wfv - Redaktionssystem',
            RESET_PASSWORD: 'Passwort zurücksetzen',
            ITEM_DETAIL: 'Details zur Einheit',
            TITLE_ENTRIES: 'Vorhandene Einträge einfügen',
            TITLE_ASSETS: 'Einfügen',
            TITLE_BACKGROUND: 'Vorhandenen Hintergrund einfügen',
            ADD: 'Hinzufügen',
            ADD_USER: 'Benutzer hinzufügen',
            ADD_FILE: 'Datei hochladen',
            ADD_ENTRIES: 'Vorhandenene Einträge einfügen',
            ADD_SELECTED_ENTRIES: 'Ausgewählte Einträge einfügen',
            ADD_NAVIGATION_ITEM: 'Navigation hinzufügen',
            ADD_PAGE: 'Seite hinzufügen',
            ARTICLE: 'Artikel',
            ADD_ARTICLE: 'Artikel hinzufügen',
            EXISTING_ARTICLE: 'Vorhandener Artikel',
            NEW_POLL: 'Neue Umfrage',
            SAVE: 'Speichern',
            TYPE: 'Typ',
            NO: 'Nein',
            EDIT: 'Bearbeiten',
            DETAILS: 'Details',
            DETAIL: 'Detail',
            PRODUCT: 'Produkt',
            PRICE: 'Preis',
            VALID_UNTIL: 'Gültig bis',
            FROM: 'aus',
            CONTAINER: 'Transportbehälter',
            ITEMS_PER_CONTAINER: 'Einheiten / Transportbehälter',
            AVAILABLE: 'Verfügbar',
            NOT_AVAILABLE: 'Nicht verfügbar',
            ADD_TO_CART: 'In den Einkaufswagen',
            IN_CART: 'Im Einkaufswagen',
            EAN8: 'EAN8',
            EAN13: 'EAN13',
            CATEGORY: 'Kategorie',
            TAGS: 'Stichworte',
            CLOSE: 'Schließen',
            TO_CHECKOUT: 'Zur Kasse',
            IN_SHOPPING_CART: 'Im Einkaufswagen',
            TODAY: 'Heute',
            SOLD_LAST_7_DAYS: 'Verkauft (letzte 7 Tage)',
            SOLD_LAST_30_DAYS: 'Verkauft (letzte 30 Tage)',
            SOLD_LAST_180_DAYS: 'Verkauft (letzte 180 Tage)',
            UNSOLD: 'Nicht verkauft',
            SOLD: 'Verkauft',
            TOTAL: 'In Summe',
            VIEW_ALL: 'Alle anzeigen',
            AVAILABLE_ITEMS: 'Verfügbare Einheiten',
            NO_AVAILABLE_ITEMS: 'Nicht verfügbare Einheiten',
            SHOPPING_CART: 'Einkaufswagen',
            NO_ITEMS: 'Einkaufswagen ist leer. Klicken Sie auf "+" in einem Produkt, um es in den Einkaufswagen zu legen.',
            DELETE_ALL: 'Alle entfernen',
            BUY: 'Kaufen',
            name: 'Name',
            volume: 'Volumen',
            deposit: 'Pfand',
            commission: 'Kommission',
            created: 'Erstellt',
            LAST_MODIFIED: 'Zuletzt bearbeitet',
            BEZIRK: 'Bezirk',
            used_in: 'Verwendet in',
            updated: 'Geändert',
            defaultVat: 'Vorschlag MwSt.',
            parentId: 'Übergeordnete Kategorie',
            icon: 'Icon',
            ordering: 'Sortierung',
            isActive: 'Ist aktiv',
            isOrganic: 'Ist bio',
            isVegan: 'Ist vegan',
            isGlutenFree: 'Ist glutenfrei',
            category: 'Kategorie',
            imageUrl: 'Bild-URL',
            image: 'Bild',
            categoryId: 'Kategorie',
            description: 'Beschreibung',
            sellerId: 'Verkäufer',
            price: 'Preis',
            unit: 'Verpackungseinheit',
            containerTypeId: 'Transportbehälter-Typ-Nummer',
            itemsPerContainer: 'Einheiten pro Transportbehälter',
            sellersProductIdentifier: 'Produkt-Nummer Verkäufer (intern)',
            ean8: 'EAN8',
            ean13: 'EAN13',
            tags: 'Stichworte',
            firstName: 'Vorname',
            lastName: 'Nachname',
            emailVerified: 'E-Mail (verifiziert)',
            isBuyer: 'Käufer',
            isSeller: 'Verkäufer',
            phone: 'Telefon',
            street: 'Straße',
            zip: 'PLZ',
            city: 'Ort',
            iban: 'IBAN',
            vat: 'MwSt.',
            email: 'E-Mail',
            regions: 'Bezirke',
            isAdmin: 'Adminrechte',
            password: 'Passwort',
            new_password: 'Neues Passwort',
            repeat_new_password: 'Neues Passwort wdh.',
            businessLicenseUrl: 'Gewerbeschein',
            companyName: 'Firmenname',
            invoiceStreet: 'Straße',
            invoiceZip: 'PLZ',
            invoiceCity: 'Ort',
            deliveryOptions: 'Lieferoptionen',
            product: 'Produkt',
            productId: 'Produkt',
            id: 'Identität',
            purchaseStatus: 'Status Verkauf',
            latestDeliveryDate: 'Spätestes Lieferdatum',
            count: 'Anzahl',
            containerTypesSingle: 'Transportbehälter',
            containerTypesPlural: 'Transportbehälter',
            categoriesSingle: 'Kategorie',
            categoriesPlural: 'Kategorien',
            trucksSingle: 'Lieferwagen',
            trucksPlural: 'Lieferwagen',
            productsSingle: 'Produkt',
            productsPlural: 'Produkte',
            usersSingle: 'Nutzer',
            usersPlural: 'Nutzer',
            itemsSingle: 'Einheit',
            itemsPlural: 'Einheiten',
            meSingle: 'Mein Profil',
            myCompanySingle: 'Meine Firma',
            buyer: 'Käufer',
            activeProductsSingle: 'aktives Produkt',
            activeProductsPlural: 'aktive Produkte',
            inactiveProductsSingle: 'inaktives Produkt',
            inactiveProductsPlural: 'inaktive Produkte',
            availableItemsSingle: 'verfügbares Produkt',
            availableItemsPlural: 'verfügbare Produkte',
            itemsInCartsSingle: 'Einheit im Einkaufswagen',
            itemsInCartsPlural: 'Einheiten im Einkaufswagen',
            paidItemsSingle: 'bezahlte Einheit',
            paidItemsPlural: 'bezahlte Einheiten',
            unsoldItemsSingle: 'unverkaufe Einheit',
            unsoldItemsPlural: 'unverkaufte Einheiten',
            EMAIL: 'E-Mail',
            PASSWORD: 'Passwort',
            REPEAT_PASSWORD: 'Passwort wdh.',
            FIRST_NAME: 'Vorname',
            LAST_NAME: 'Nachname',
            BUSINESS_LICENSE: 'Gewerbeschein',
            PDF_LICENSE: 'PDF Lizenz',
            SELLER_DECLARE: 'Auch Verkäufer',
            BUYER: 'Käufer',
            SELLER: 'Verkäufer',
            ADMIN: 'Administrator',

            RESTRICTED_ACCESS: 'Gesperrter Bereich',
            RESTRICTED_ACCESS_MESSAGE_ADMIN: 'Sie müssen Administrator sein, um diesen Bereich zu besuchen.',
            RESTRICTED_ACCESS_MESSAGE_SELLER: 'Sie müssen Verkäufer sein, um diesen Bereich zu besuchen.',
            RESTRICTED_ACCESS_MESSAGE_BUYER: 'Sie müssen Käufer sein, um diesen Bereich zu besuchen',

            SEARCH_RESULTS_HEADING: 'Suchergebnisse für: ',
            SEARCH_RESULTS_FAILURE: 'Fehler beim Laden der Suchergebnisse',

            FAILED_LOGOUT_NOTIFICATION: 'Fehler beim Abmelden',

            HTTP_POST_SUCCESS_NOTIFICATION: ' erfolgreich geladen', // leading space needed
            HTTP_POST_ERROR_NOTIFICATION: 'Fehler beim Hinzufügen',
            HTTP_GET_ERROR_NOTIFICATION: 'Fehler beim Laden',
            HTTP_PUT_SUCCESS_NOTIFICATION: ' erfolgreich aktualisiert', // leading space needed
            HTTP_PUT_ERROR_NOTIFICATION: 'Fehler beim Aktualisieren',
            HTTP_DELETE_SUCCESS_NOTIFICATION: ' erfolgreich gelöscht', // leading space needed
            HTTP_DELETE_ERROR_NOTIFICATION: 'Fehler beim Löschen',
            HTTP_UPLOAD_ERROR_NOTIFICATION: 'Ein unerwarteter Fehler ist auf unseren Servern aufgetreten. Bitte versuchen Sie es erneut.',

            LOG_IN_TO_SEE_PRICE: 'Anmelden für Preisinformation',

            NO_OF_ITEMS: 'Anzahl Einheiten',

            DELIVERY_OPTION: 'Lieferoption',
            DELIVERY_OPTIONS: 'Lieferoptionen',
            MC_SWISS_DELIVERY: 'Meck-Schweizer Lieferung',
            SELLER_DELIVERY: 'Durch Verkäufer',
            SELF_COLLECT: 'Selbstabholung',
            DELIVERY_FEE: 'Liefergebühr',
            DELIVERY_TOTAL: 'Lieferkosten gesamt',
            DELIVERY_ADDRESS: 'Lieferadresse',
            SAVED_ADDRESS: 'Gespeicherte Adresse',

            REGISTRATION_CONFIRMATION: 'Vielen Dank für Ihre Registrierung. Sie erhalten gleich eine E-Mail. Bitte klicken Sie auf den Bestätigungslink, um die Registrierung abzuschließen.',

            PASSWORDS_MUST_MATCH: 'Passwörter stimmen nicht überein',

            COMPANY_ADDRESS: 'Firmenanschrift',
            COLLECTION_ADDRESS: 'Adressen',
            SAME_COMPANY_COLLECTION_ADDRESS: 'Firmenanschrift als Lieferanschrift verwenden',

            COMPANY_NAME: 'Firma',
            STREET: 'Straße & Nummer',
            ZIP: 'PLZ',
            CITY: 'Ort',

            MORE: 'mehr',
            PAYMENT_OPTION: 'Zahlung',
            CREDIT_CARD: 'Kreditkarte',
            EUROCASH: 'EC',
            DIRECT_DEBIT: 'Direktüberweisung',

            NAME_ON_CARD: 'Karteninhaber',
            CARD_NUMBER: 'Kartennummer',
            EXPIRY_DATE: 'Kartenablaufdatum',
            CVC: 'KartenCVC',

            CHECKOUT: 'Zur Kasse',
            CONTINUE_SHOPPING: 'Abbrechen',
            PROCEED: 'Weiter',
            BACK: 'Zurück',
            PLACE_ORDER: 'Kaufen',

            REGISTER_OR_LOG_IN: 'Registrieren oder anmelden',

            BILLING: 'Rechnung',
            DELIVERY: 'Lieferung',
            PAYMENT: 'Zahlung',
            SUMMARY: 'Zusammenfassung',

            CHECKOUT_EXIT_CONFIRMATION: 'Sind Sie sicher, dass Sie den Kaufprozess abbrechen möchten?',
            EXIT: 'Ja, abbrechen',

            overview: 'Übersicht',
            products: 'Produkte',
            items: 'Einheiten',
            activeProducts: 'Aktive Produkte',
            inactiveProducts: 'Inaktive Produkte',
            availableItems: 'Verfügbare Einheiten',
            itemsInCarts: 'Einheiten im Einkaufswagen',
            paidItems: 'Verkaufte Einheiten',
            unsoldItems: 'Unverkaufte Einheiten',

            profile: 'Profil',
            purchases: 'Einkäufe',

            CHECKOUT_TOTAL_TOO_LOW: 'Der Mindestbestellwert beträgt 50 €. Bitte fügen Sie weitere Produkte Ihrem Einkaufswagen hinzu.',

            SHOPPING_CART_POST_ERROR_NOTIFICATION: 'Fehler beim Erstellen des Einkaufswagens',
            SHOPPING_CART_GET_ERROR_NOTIFICATION: 'Fehler beim Laden des Einkaufswagens',
            SHOPPING_CART_PUT_ERROR_NOTIFICATION: 'Fehler beim Hinzufügen von Einheiten zum Einkaufswagen',
            SHOPPING_CART_PUT_MISMATCH_NOTIFICATION: 'Von diesem Produkt sind keine weiteren Einheiten verfügbar',

            REMOVE: 'Entfernen',
            PUBLISH: 'Veröffentlichen',

            // 404 page
            PAGE_NOT_FOUND: 'Seite nicht gefunden',
            BACK_TO_MAIN_PAGE: 'Zurück zur Startseite',
            PAGE_NOT_EXIST: 'Die Seite existiert nicht oder Sie besitzen keine Zugriffsrechte.',

            // Password reset
            FORGOT_YOUR_PASSWORD: 'Passwort vergessen',
            REMEMBER_YOUR_PASSWORD: 'Passwort merken',
            PASSWORD_RESET_INFO: 'Bitte geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link, um das Passwort zu ändern.',
            RESET: 'Zurücksetzen',
            PASSWORD_RESET_REQUEST_SUCCESS: 'Wir haben Ihnen einen Passwort-zurücksetzen-Link geschickt. Bitte folgenden Sie den Hinweisen in der E-Mail.',
            SET_PASSWORD_SUCCESS: 'Ihr Passwort wurde geändert. Sie können sich nun mit Ihrem neuen Passwort anmelden.',
            CHANGE_PASSWORD: 'Passwort ändern',

            // Buyer/purchases
            ID: 'Kennung',
            DATE: 'Datum',
            STATUS: 'Status',

            // Profile
            me: 'Mein Profil',
            myCompany: 'Meine Firma',

            // Verify email
            VERIFY_EMAIL_SUCCESS: 'Ihre E-Mail-Adresse wurde erfolgreich bestätigt.',
            VERIFY_EMAIL_ERROR: 'Fehler beim Bestägtigen Ihrer E-Mail-Adresse. Bitte registrieren Sie sich und klicken Sie auf den Link in der Bestätigungsmail.',

            // Product lists
            NO_PRODUCTS_FOUND: 'Keine Produkte gefunden',

            // Footer links
            IMPRINT: 'Impressum',
            TERMS_OF_USE: 'Nutzungsbedingungen',
            DATA_PROTECTION: 'Datenschutzerklärung',
            FAQ: 'Häufige Fragen',

            // Order confirmation
            ORDER_CONFIRMATION: 'Vielen Dank für Ihren Einkauf!',
            ORDER_NUMBER: 'Bestellnummer',
            ORDER_EMAIL_CONFIRMATION: 'Die Details zu Ihrer Bestellung erhalten Sie in Kürze per E-Mail.',
            BILLING_ADDRESS: 'Rechnungs-Adresse',
            PRODUCTS_AND_DELIVERY: 'Produkte und Lieferung',
            TO: 'an',
            PRODUCTS_TOTAL: 'Produkte insgesamt',
            ORDER_TOTAL: 'Bestellung insgesamt',

            // Form controls
            SELECT_VALUE: '-- Wert auswählen --',

            // Items add modal
            ADD_ITEMS_AFTER_PRODUCT_ADD: 'Möchten Sie Artikel zu diesem Produkt hinzufügen?',

            // Admin overview
            ACTIVE_USERS: 'Aktive Benutzer',
            SALES: 'Verkäufe',
            PRODUCTS_ON_SALE: 'Produkte im Angebot',
            SELLERS: 'Verkäufer',
            BUYERS: 'Käufer',
            LAST_7_DAYS: 'Letzte 7 Tage',
            LAST_30_DAYS: 'Letzte 30 Tage',
            YESTERDAY: 'gestern',
            PREVIOUS_PERIOD: 'Letzte Periode',
            NO_CHANGE: 'Keine Änderung',

            // Product characteristics
            ORGANIC: 'Bio',
            VEGAN: 'Vegan',
            SUGAR_FREE: 'Zuckerfrei',
            GLUTEN_FREE: 'Glutenfrei',
            GMO_FREE: 'Ohne Gentechnik',

            // Drag and drop file upload
            DRAG_AND_DROP: 'Oder ziehen Sie Ihre Datei hier rein.',
            BROWSE: 'Durchsuchen',

            // File download
            DOWNLOAD: 'Herunterladen',

            LATITUDE: 'Breitengrad',
            LONGITUDE: 'Längengrad',

            validation: {
                required: 'Erforderlich',
                pattern: {
                    l: 'Nur Buchstaben zulässig',
                    ln: 'Nur Buchstaben und Ziffern zulässig',
                    lnsc: 'Nur Buchstaben, Ziffern, Leerzeichen und Kommas zulässig',
                    lnscda: 'Nur Buchstaben, Ziffern, Leerzeichen, Kommas und Punkte zulässig',
                    lnscdad: 'Nur Buchstaben, Ziffern, Leerzeichen, Kommas, Punkte, Bindestriche und kaufmännische Und-Zeichen zulässig',
                    ean8: 'EAN8 muss 8 Ziffern haben',
                    ean13: 'EAN13 muss 13 Ziffern haben',
                    zip: 'PLZ muss aus 5 Ziffern bestehen',
                    password: 'Passwort muss 8-20 Zeichen lang sein, einen kleinen, einen großen Buchstaben und eine Zahl beinhalten',
                    image: 'Nur Bild-Dateien zulässig',
                    imageOrPdf: 'Nur Bilder und PDFs zulässig'
                },
                minlength: {
                    2: 'Mindestens 2 Zeichen erforderlich',
                    8: 'Mindestens 8 Zeichen erforderlich'
                },
                maxlength: {
                    20: 'Höchstens 20 Zeichen zulässig',
                    30: 'Höchstens 30 Zeichen zulässig'
                },
                min: {
                    0: 'Wert muss positiv sein'
                },
                max: {
                    100: 'Wert muss kleiner sein als 100'
                },
                maxSize: {
                    5: 'Maximale Dateigröße von 5MB überschritten'
                },
                maxHeight: {
                    1000: 'Maximale Dateigröße von 1000 Pixel überschritten',
                    2000: 'Maximale Dateigröße von 2000 Pixel überschritten'
                },
                number: 'Ungültige Nummer',
                date: 'Ungültiges Datum',
                email: 'Ungültige E-Mail',
                iban: 'Ungültige IBAN'
            },
            CHANGE_BACKGROUND: 'Hintergrundbild ändern',
            NO_REGION_SET: 'Kein Bezirk hinterlegt',
            AUTHOR: 'Autor',
            TITLE: 'Überschrift',
            DOWNLOADED: 'Heruntergeladen',
            TIMES: 'mal',
            EMPTY: 'Unbenannt',
            FILENAME: 'Dateiname',
            WELCOME_CMS: 'Willkommen im wfv-Redaktionssystem!',
            NAVIGATION_ITEM_SELECTED: 'Ausgewählte Navigation',
            NO_ASSOCIATED_PAGE: 'Keine zugeordnete Seite vorhanden',
            NO_ASSOCIATED_ARTICLE: 'Keine zugeordneten Artikel vorhanden',
            NO_FILES: 'Keine Dateien vorhanden',
            PERMISSIONS: 'Rechte',
            GRANT_ADMIN_RIGHTS: 'Adminrechte vergeben',
            EMAIL_REQ: 'E-Mail-Adresse ungültig oder erforderlich',
            PASSWD_RQ: 'Passwort erforderlich',
            PASSWORD_NOT_EQUALS: 'Passwörter sind nicht identisch',
            USER_RQ: 'Profilname erforderlich',
            LINK_REQ: 'Link ist ungültig oder erforderlich',
            SEARCH_REQ: 'Suche ist nicht vorhanden',
            TITLE_REQ: 'Titel erforderlich',
            TITLE_RANGE_REQ: 'Benötigt zwischen 2 und 100 Zeichen',
            SELECT_FILE: 'Datei auswählen',
            REPLACE_FILE: 'Datei ersetzen',
            DROP_FILE: 'Datei hier ablegen',
            OR: ' oder ',
            SELECT_DROP_FILE: 'Datei auswählen',
            ADD_IMAGE_VIDEO: 'Bild / Video hinzufügen',
            ADD_IMAGE: 'Bild hinzufügen',
            IMAGE_PREVIEW: 'Vorschau',
            LINK_EXISTING_ASSETS: 'Vorhandene Dateien einbinden',
            CREATE_NEW_ARTICLE: 'Einen neuen Artikel erstellen',
            LINK_EXISTING_ARTICLES: 'Vorhandenen Artikel einbinden',
            REMOVE_IMAGE: 'Um das Bild zu entfernen, muss der Artikel gespeichert werden.',
            IMAGES: 'Bilder',
            SORT_BY_DATE: 'Nach Datum sortieren',
            SORT_ASC: 'aufsteigend',
            SORT_DESC: 'absteigend',
            WIDTH_GREATER_EQUAL: 'Breite ist größer als oder gleich (in Pixel)',
            NAVIGATION: 'Navigation',
            KEYWORDS: 'Schlagwörter',
            NEW_KEYWORDS: 'Neue Schlagwörter',
            TRY_AGAIN: 'Upload fehlgeschlagen - Erneut probieren?',
            NEW_WINDOW: 'Link in neuem Tab öffnen',
            SHOW_MORE: 'Mehr anzeigen...',
            WRONG_PASSWORD: 'Das Passwort ist ungültig oder der Nutzer hat noch kein Passwort vergeben.',
            INVALID_EMAIL: 'Die E-Mail-Adresse ist falsch formatiert.',
            AUTH_WEAK_PASSWORD: 'Das Passwort muss aus mindestens 6 Zeichen bestehen.',
            AUTH_EMAIL_ALREADY_IN_USE: 'Die E-Mail-Adresse ist bereits in Verwendung.',
            AUTH_INTERNAL_ERROR: 'Interner Fehler: Bitte versuchen Sie es erneut.',
            EXIT_MESSAGE: 'Sind Sie sicher, dass sie das die Seite verlassen wollen?',
            AUTH_USER_NOT_FOUND: 'Kein Benutzer mit diesen Benutzerdaten verfügbar. Der Benutzer wurde möglicherweise gelöscht',
            MESSAGE_RELOAD_PAGE: 'Es gibt ungespeicherte Änderungen im Formular. Wollen Sie die Seite wirklich verlassen?',
            REQUIRES_RECENT_LOGIN: 'Dieser Vorgang erfordert eine neue Authentifizierung. Bitte melden Sie sich erneut an, bevor Sie diese Anfrage wiederholen.',
            BOLD_TOOLTIP: 'Fett',
            ITALIC_TOOLTIP: 'Kursiv',
            QUOTE_TOOLTIP: 'Zitat',
            INSERTLINK_TOOLTIP: 'Link setzen',
            UL_TOOLTIP: 'Unsortierte Liste',
            INSERTEMAIL_TOOLTIP: 'Email an',
            LINK_OPTIONS: 'Link Optionen',
            EXTERNAL_LINK: 'Externer Link',
            INTERNAL_LINK_ARTICLE: 'Interner Link zu einem Artikel',
            INTERNAL_LINK_FILE: 'Interner Link zu einer Datei',
            EDIT_IMAGE: 'Bild bearbeiten',
            ROTATE_LEFT: ' (links drehen) ',
            ROTATE_RIGHT: ' (rechts drehen) ',
            ZOOM_IN: ' (heranzoomen) ',
            ZOOM_OUT: ' (herauszoomen) ',
            FIT: ' (passend) ',
            CROP: ' [speichern] ',
            APPLY_BRIGHTNESS: 'Helligkeit ändern',
            TEXT: 'Text',
            TABLE: 'Tabelle',
            OPTION: 'Optionen',
            RESULTS: 'Ergebnisse',
            PRIVACY_1: 'Ich akzeptiere die',
            PRIVACY_2: 'Datenschutzbestimmungen.',
            PRIVACY_TITLE_COOKIES: 'Cookies',
            PRIVACY_BODY_COOKIES: 'Cookies sind Textdateien, die automatisch bei dem Aufruf einer Onlinepräsenz lokal im Browser des Besuchers abgelegt werden. Diese Website setzt Cookies ein, um das Angebot nutzerfreundlich und funktionaler zu machen. Dank dieser Dateien ist es beispielsweise möglich, dass Sie speziell auf Ihre Interessen abgestimmte Informationen auf der Seite angezeigt bekommen. Auch Sicherheitsrelevante Funktionen zum Schutz Ihrer Privatsphäre werden durch den Einsatz von Cookies ermöglicht. Der ausschließliche Zweck besteht also darin, unser Angebot Ihren Kundenwünschen bestmöglich anzupassen und Ihnen das Surfen bei uns so komfortabel wie möglich zu gestalten und die Navigation zu erleichtern. Diese Website folgt der Richtlinie (§96.Abs.3.TKG.06) zum Nutzerhinweis auf die Verwendung von Cookies und den Datenschutz.',
            PRIVACY_TITLE_ANALYTICS: 'Google Analytics',
            PRIVACY_BODY_ANALYTICS: 'Dieses Angebot nutzt ebenfalls den Webanalysedienst Google Analytics, ein Programm der Google Inc. (\\"Google, USA\\"). Die durch das Tracking erfassten Informationen zu Ihrer Nutzung dieser Website werden auf einem Server von Google in den USA gespeichert. Durch eine sogenannte IP-Anonymisierung wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Somit ist der Standort Ihres Browsers lediglich regional zuortbar, nicht aber ihrer Person. Google kann Besucherverhalten auswerten, um Reports über die Websiteaktivitäten zusammenzustellen. Auch weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen können so gegenüber dem Websitebetreiber erbracht werden.'
        };

        return translations;
    }

    function getEnglishKey() {
        let translations = {
            HOME: 'Home',
            HELLO: 'Hello',
            BUYING_SECTION_HEADER: 'Buying',
            SELLING_SECTION_HEADER: 'Selling',
            ADMIN_SECTION_HEADER: 'Admin',
            LANGUAGE: 'Language',
            REGISTER: 'Register',
            LOG_IN: 'Log in',
            PROFILE: 'Profile',
            PURCHASES: 'Purchases',
            NO_PURCHASES: 'No purchases',
            DELIVERIES: 'Deliveries',
            PAYMENTS: 'Payments',
            LOG_OUT: 'Log out',
            SLOGAN: 'Local food marketplace',
            SEARCH: 'Search',
            SEARCH_PLACEHOLDER: 'Search by product or category name',
            CATEGORIES: 'Categories',
            OVERVIEW: 'Overview',
            CONTAINER_TYPES: 'Container types',
            TRUCKS: 'Trucks',
            PRODUCTS: 'Products',
            USER: 'User',
            USERS: 'Users',
            FILES: 'Files',
            ITEMS: 'Items',
            PAGES: 'Pages',
            ARTICLES: 'Articles',
            PAGE: 'Page',
            LINK: 'Link',
            FILE: 'File',
            SHOPPING_CARTS: 'Shopping carts',
            DELETE_ITEM: 'Delete item',
            SURE_TO_DELETE: 'Are you sure you want to delete this item?',
            CANCEL: 'Cancel',
            CHANGE_PASSWORD: 'Change Password',
            DELETE: 'Delete',
            GO: 'Go',
            LOGIN: 'LOGIN',
            RESET_PASSWORD: 'RESET PASSWORD',
            TITLE_WTF: 'wfv - Content Management System',
            ITEM_DETAIL: 'Item detail',
            TITLE_ENTRIES: 'Insert existing entries',
            TITLE_ASSETS: 'Insert existing assets',
            TITLE_BACKGROUND: 'Insert existing background',
            ADD: 'Add',
            ADD_USER: 'Add User',
            ADD_ENTRIES: 'Insert available entries',
            ADD_SELECTED_ENTRIES: 'Insert selected entries',
            ADD_FILE: 'Add File',
            ADD_PAGE: 'Add Page',
            SAVE: 'Save',
            TYPE: 'Type',
            NO: 'No',
            EDIT: 'Edit',
            DETAILS: 'Details',
            DETAIL: 'Detail',
            PRODUCT: 'Product',
            PRICE: 'Price',
            VALID_UNTIL: 'Valid until',
            FROM: 'from',
            CONTAINER: 'Container',
            ITEMS_PER_CONTAINER: 'Items / container',
            AVAILABLE: 'Available',
            NOT_AVAILABLE: 'N/A',
            ADD_TO_CART: 'Add to cart',
            ADD_NAVIGATION_ITEM: 'Add navigation item',
            ARTICLE: 'Article',
            ADD_ARTICLE: 'Add article',
            EXISTING_ARTICLE: 'Existing Article',
            NEW_POLL: 'New Poll',
            IN_CART: 'In cart',
            EAN8: 'EAN8',
            EAN13: 'EAN13',
            CATEGORY: 'Category',
            TAGS: 'Tags',
            CLOSE: 'Close',
            TO_CHECKOUT: 'To checkout',
            IN_SHOPPING_CART: 'In your shopping cart',
            TODAY: 'Today',
            SOLD_LAST_7_DAYS: 'Sold(last 7 days)',
            SOLD_LAST_30_DAYS: 'Sold(last 30 days)',
            SOLD_LAST_180_DAYS: 'Sold(last 180 days)',
            UNSOLD: 'Unsold',
            SOLD: 'Sold',
            TOTAL: 'Total',
            VIEW_ALL: 'View all',
            AVAILABLE_ITEMS: 'Available items',
            NO_AVAILABLE_ITEMS: 'No available items',
            SHOPPING_CART: 'Shopping cart',
            NO_ITEMS: 'No items',
            DELETE_ALL: 'Delete all',
            BUY: 'Buy',
            LAST_MODIFIED: 'Last Modified',
            BEZIRK: 'Region',
            name: 'Name',
            volume: 'Volume',
            deposit: 'Deposit',
            commission: 'Commission',
            created: 'Created',
            used_in: 'Used in',
            updated: 'Updated',
            defaultVat: 'Default VAT',
            parentId: 'Parent',
            icon: 'Icon',
            ordering: 'Ordering',
            isActive: 'Is active',
            isOrganic: 'Is organic',
            isVegan: 'Is vegan',
            isGlutenFree: 'Is gluten free',
            category: 'Category',
            imageUrl: 'Image',
            image: 'Image',
            categoryId: 'Category',
            description: 'Description',
            sellerId: 'Seller',
            price: 'Price',
            unit: 'Unit',
            containerTypeId: 'Container type',
            itemsPerContainer: 'Items per container',
            sellersProductIdentifier: 'Sellers product identifier',
            ean8: 'EAN8',
            ean13: 'EAN13',
            tags: 'Tags',
            firstName: 'First name',
            lastName: 'Last name',
            emailVerified: 'Email verified',
            isBuyer: 'Is buyer',
            isSeller: 'Is seller',
            phone: 'Phone',
            street: 'Street',
            zip: 'ZIP',
            city: 'City',
            iban: 'IBAN',
            vat: 'VAT',
            email: 'Email',
            regions: 'Regions',
            isAdmin: 'Is Admin',
            password: 'Password',
            new_password: 'New Password',
            repeat_new_password: 'Repeat new password',
            businessLicenseUrl: 'Business license',
            companyName: 'Company name',
            invoiceStreet: 'Street',
            invoiceZip: 'ZIP',
            invoiceCity: 'City',
            deliveryOptions: 'Delivery options',
            product: 'Product',
            productId: 'Product',
            id: 'Identifier',
            purchaseStatus: 'Purchase status',
            latestDeliveryDate: 'Latest delivery date',
            count: 'Count',
            containerTypesSingle: 'container type',
            containerTypesPlural: 'container types',
            categoriesSingle: 'category',
            categoriesPlural: 'categories',
            trucksSingle: 'truck',
            trucksPlural: 'trucks',
            productsSingle: 'product',
            productsPlural: 'products',
            usersSingle: 'user',
            usersPlural: 'users',
            itemsSingle: 'item',
            itemsPlural: 'items',
            meSingle: 'me',
            myCompanySingle: 'my company',
            buyer: 'Buyer',
            activeProductsSingle: 'active product',
            activeProductsPlural: 'active products',
            inactiveProductsSingle: 'inactive product',
            inactiveProductsPlural: 'inactive products',
            availableItemsSingle: 'available item',
            availableItemsPlural: 'available items',
            itemsInCartsSingle: 'item in cart',
            itemsInCartsPlural: 'items in cart',
            paidItemsSingle: 'paid item',
            paidItemsPlural: 'paid items',
            unsoldItemsSingle: 'unsold item',
            unsoldItemsPlural: 'unsold items',
            EMAIL: 'Email',
            PASSWORD: 'Password',
            REPEAT_PASSWORD: 'Repeat password',
            FIRST_NAME: 'First name',
            LAST_NAME: 'Last name',
            BUSINESS_LICENSE: 'Business license',
            PDF_LICENSE: 'PDF License',
            SELLER_DECLARE: 'I want to be a seller too',
            BUYER: 'Buyer',
            SELLER: 'Seller',
            ADMIN: 'Admin',

            RESTRICTED_ACCESS: 'Restricted access',
            RESTRICTED_ACCESS_MESSAGE_ADMIN: 'You have to be an admin to access this section',
            RESTRICTED_ACCESS_MESSAGE_SELLER: 'You have to be a seller to access this section',
            RESTRICTED_ACCESS_MESSAGE_BUYER: 'You have to be a buyer to access this section',

            SEARCH_RESULTS_HEADING: 'Search results for: ',
            SEARCH_RESULTS_FAILURE: 'Failed to fetch search results',

            FAILED_LOGOUT_NOTIFICATION: 'Failed to logout',

            HTTP_POST_SUCCESS_NOTIFICATION: ' successfully added',// leading space needed
            HTTP_POST_ERROR_NOTIFICATION: 'Failed to add ',
            HTTP_GET_ERROR_NOTIFICATION: 'Failed to fetch ',
            HTTP_PUT_SUCCESS_NOTIFICATION: ' successfully updated',// leading space needed
            HTTP_PUT_ERROR_NOTIFICATION: 'Failed to update ',
            HTTP_DELETE_SUCCESS_NOTIFICATION: ' successfully deleted',// leading space needed
            HTTP_DELETE_ERROR_NOTIFICATION: 'Failed to delete ',
            HTTP_UPLOAD_ERROR_NOTIFICATION: 'Something wrong happened on our servers, please try again.',

            LOG_IN_TO_SEE_PRICE: 'Log in to see price',

            NO_OF_ITEMS: 'Number of items',

            DELIVERY_OPTION: 'Delivery option',
            DELIVERY_OPTIONS: 'Delivery options',
            MC_SWISS_DELIVERY: 'McSwiss delivery',
            SELLER_DELIVERY: 'Seller delivery',
            SELF_COLLECT: 'Self collect',
            DELIVERY_FEE: 'Delivery fee',
            DELIVERY_TOTAL: 'Delivery total',
            DELIVERY_ADDRESS: 'Delivery address',
            SAVED_ADDRESS: 'Saved address',

            REGISTRATION_CONFIRMATION: 'Thank you for registering. Click the link sent to your email address complete the registration.',

            PASSWORDS_MUST_MATCH: 'Passwords must match',

            COMPANY_ADDRESS: 'Company address',
            COLLECTION_ADDRESS: 'Collection address',
            SAME_COMPANY_COLLECTION_ADDRESS: 'Use company address for collection',

            COMPANY_NAME: 'Company name',
            STREET: 'Street',
            ZIP: 'ZIP',
            CITY: 'City',
            MORE: 'More...',

            PAYMENT_OPTION: 'Option',
            CREDIT_CARD: 'Credit card',
            EUROCASH: 'Eurocash',
            DIRECT_DEBIT: 'Direct debit',

            NAME_ON_CARD: 'Name on card',
            CARD_NUMBER: 'Card number',
            EXPIRY_DATE: 'Card expiry date',
            CVC: 'Card CVC',

            CHECKOUT: 'Checkout',
            CONTINUE_SHOPPING: 'Continue shopping',
            PROCEED: 'Proceed',
            BACK: 'Back',
            PLACE_ORDER: 'Place order',

            REGISTER_OR_LOG_IN: 'Register or log in',

            BILLING: 'Billing',
            DELIVERY: 'Delivery',
            PAYMENT: 'Payment',
            SUMMARY: 'Summary',

            CHECKOUT_EXIT_CONFIRMATION: 'Are you sure you want to exit the checkout process?',
            EXIT: 'Exit',

            overview: 'Overview',
            products: 'Products',
            items: 'Items',
            activeProducts: 'Active products',
            inactiveProducts: 'Inactive products',
            availableItems: 'Available items',
            itemsInCarts: 'Items in carts',
            paidItems: 'Paid items',
            unsoldItems: 'Unsold items',

            profile: 'Profile',
            purchases: 'Purchases',

            CHECKOUT_TOTAL_TOO_LOW: 'To checkout your cart the total price must be minimum 50€. Please add more items below or continue shopping.',

            SHOPPING_CART_POST_ERROR_NOTIFICATION: 'Failed to create shopping cart',
            SHOPPING_CART_GET_ERROR_NOTIFICATION: 'Failed to fetch shopping cart',
            SHOPPING_CART_PUT_ERROR_NOTIFICATION: 'Failed to add items to shopping cart',
            SHOPPING_CART_PUT_MISMATCH_NOTIFICATION: 'More items of this product might not be available',

            REMOVE: 'Remove',
            PUBLISH: 'Publish',

            // 404 page
            PAGE_NOT_FOUND: 'Page not found',
            BACK_TO_MAIN_PAGE: 'Go back to main page',
            PAGE_NOT_EXIST: 'The page doesn\'t exist or you don\'t have access permission to view it',

            // Password reset
            FORGOT_YOUR_PASSWORD: 'Forgot your password?',
            REMEMBER_YOUR_PASSWORD: 'Remember your password?',
            PASSWORD_RESET_INFO: 'Please enter your email address. A password reset link will be sent to you to complete the password change process.',
            RESET: 'Reset',
            PASSWORD_RESET_REQUEST_SUCCESS: 'A password change link has been sent to your email address. Please follow instructions in the email to change your password.',
            SET_PASSWORD_SUCCESS: 'Your password has been changed. Please login with your new password.',
            CHANGE_PASSWORD: 'Change password',

            // Buyer/purchases
            ID: 'Id',
            DATE: 'Date',
            STATUS: 'Status',

            // Profile
            me: 'Me',
            myCompany: 'My company',

            // Verify email
            VERIFY_EMAIL_SUCCESS: 'Your email has been successfully verified',
            VERIFY_EMAIL_ERROR: 'Failed to verify your email. Please register and click the link in your email',

            // Product lists
            NO_PRODUCTS_FOUND: 'No products found',

            // Footer links
            IMPRINT: 'Imprint',
            TERMS_OF_USE: 'Terms of use',
            DATA_PROTECTION: 'Data protection',
            FAQ: 'FAQ',

            // Order confirmation
            ORDER_CONFIRMATION: 'Thank you for shopping with us!',
            ORDER_NUMBER: 'Order number',
            ORDER_EMAIL_CONFIRMATION: 'Order details will be sent to your email shortly',
            BILLING_ADDRESS: 'Billing address',
            PRODUCTS_AND_DELIVERY: 'Products and delivery',
            TO: 'to',
            PRODUCTS_TOTAL: 'Products total',
            ORDER_TOTAL: 'Order total',

            // Form controls
            SELECT_VALUE: '-- select value --',

            // Items add modal
            ADD_ITEMS_AFTER_PRODUCT_ADD: 'Would you like to add items for this product?',

            // Admin overview
            ACTIVE_USERS: 'Active users',
            SALES: 'Sales',
            PRODUCTS_ON_SALE: 'Products on sale',
            SELLERS: 'Sellers',
            BUYERS: 'Buyers',
            LAST_7_DAYS: 'Last 7 days',
            LAST_30_DAYS: 'Last 30 days',
            YESTERDAY: 'yesterday',
            PREVIOUS_PERIOD: 'previous period',
            NO_CHANGE: 'No change',

            // Product characteristics
            ORGANIC: 'Organic',
            VEGAN: 'Vegan',
            SUGAR_FREE: 'Sugar free',
            GLUTEN_FREE: 'Gluten free',
            GMO_FREE: 'GMO free',

            // Drag and drop file upload
            DRAG_AND_DROP: 'Or drag and drop file here',
            BROWSE: 'Browse',

            // File download
            DOWNLOAD: 'Download',

            LATITUDE: 'Latitude',
            LONGITUDE: 'Longitude',

            validation: {
                required: 'Required',
                pattern: {
                    l: 'Only letters allowed',
                    ln: 'Only letters and numbers allowed',
                    lnsc: 'Only letters, numbers, spaces and commas allowed',
                    lnscda: 'Only letters, numbers, spaces, commas, dots and ampersands allowed',
                    lnscdad: 'Only letters, numbers, spaces, commas, dots, ampersands and dashes allowed',
                    ean8: 'EAN8 has to be 8 digits long',
                    ean13: 'EAN13 has to be 13 digits long',
                    zip: 'ZIP has to be 5 digits long',
                    password: 'Password has to be 8-20 characters long, contain large and small letter and number',
                    image: 'Only image files allowed',
                    imageOrPdf: 'Only image and pdf files allowed'
                },
                minlength: {
                    2: 'Minimum 2 characters required',
                    8: 'Minimum 8 characters required'
                },
                maxlength: {
                    20: 'Maximum 20 characters allowed',
                    30: 'Maximum 30 characters allowed'
                },
                min: {
                    0: 'Value cannot be negative'
                },
                max: {
                    100: 'Value cannot be greater than 100'
                },
                maxSize: {
                    5: 'Maximum file size of 5MB exceeded'
                },
                maxHeight: {
                    1000: 'Maximum file height of 1000 pixels exceeded',
                    2000: 'Maximum file height of 2000 pixels exceeded'
                },
                number: 'Invalid number',
                date: 'Invalid date',
                email: 'Invalid email',
                iban: 'Invalid iban'
            },
            CHANGE_BACKGROUND: 'Change background image',
            NO_REGION_SET: 'No region set',
            AUTHOR: 'Author',
            TITLE: 'Title',
            DOWNLOADED: 'Downloaded',
            TIMES: 'times',
            EMPTY: 'Empty',
            FILENAME: 'Filename',
            WELCOME_CMS: 'Welcome to the WFV Content Management System',
            NAVIGATION_ITEM_SELECTED: 'Navigation Item selected',
            NO_ASSOCIATED_PAGE: 'there isn\'t any associated page',
            NO_ASSOCIATED_ARTICLE: 'there isn\'t any associated article',
            NO_FILES: 'There aren\'t any files',
            PERMISSIONS: 'Permissions',
            GRANT_ADMIN_RIGHTS: 'Grant admin rights',
            EMAIL_REQ: 'Your email is invalid or required.',
            PASSWD_RQ: 'Your password is required.',
            PASSWORD_NOT_EQUALS: 'Passwords don\'t match.',
            USER_RQ: 'Your profilename is required.',
            LINK_REQ: 'Link is invalid or required.',
            SEARCH_REQ: 'Search is required.',
            TITLE_REQ: 'Please provide a title.',
            TITLE_RANGE_REQ: 'Requires between 2 and 50 characters.',
            SELECT_FILE: 'Select file',
            REPLACE_FILE: 'Replace file',
            DROP_FILE: 'drop file',
            OR: ' or ',
            SELECT_DROP_FILE: 'Select file or drop file',
            ADD_IMAGE_VIDEO: 'Add image/video',
            ADD_IMAGE: 'Add image',
            IMAGE_PREVIEW: 'Preview',
            LINK_EXISTING_ASSETS: 'Link existing assets',
            CREATE_NEW_ARTICLE: 'Create a new article',
            LINK_EXISTING_ARTICLES: 'Link existing articles',
            REMOVE_IMAGE: 'In order to remove the image you need to save the article.',
            IMAGES: 'Images',
            SORT_BY_DATE: 'Sort by date',
            SORT_ASC: 'ascending',
            SORT_DESC: 'descending',
            WIDTH_GREATER_EQUAL: 'Width is greater than or equal to (in pixel)',
            NAVIGATION: 'Navigation',
            KEYWORDS: 'Keywords',
            NEW_KEYWORDS: 'New keywords',
            TRY_AGAIN: 'Upload failed. Try again.',
            NEW_WINDOW: 'Open in New Window',
            SHOW_MORE: 'Show more...',
            WRONG_PASSWORD: 'The password is invalid or the user hasn\'t set a password yet.',
            INVALID_EMAIL: 'The email address is badly formatted.',
            AUTH_WEAK_PASSWORD: 'The password must at least contain 6 characters.',
            AUTH_EMAIL_ALREADY_IN_USE: 'The email address is already in use.',
            AUTH_INTERNAL_ERROR: 'Intern Error. Please try again.',
            AUTH_USER_NOT_FOUND: 'There is no user record corresponding to this identifier. The user may have been deleted.',
            EXIT_MESSAGE: 'Are you sure to leave this page?',
            MESSAGE_RELOAD_PAGE: 'You have unsaved changes, do you want to continue?',
            REQUIRES_RECENT_LOGIN: 'This operation is sensitive and requires recent authentification. Login again before retrying this request.',
            BOLD_TOOLTIP: 'Bold',
            ITALIC_TOOLTIP: 'Italic',
            QUOTE_TOOLTIP: 'Quote/unquote selection or paragraph',
            INSERTLINK_TOOLTIP: 'Insert / edit link',
            UL_TOOLTIP: 'Unordered List',
            INSERTEMAIL_TOOLTIP: 'Insert / edit email',
            LINK_OPTIONS: 'Link Options',
            EXTERNAL_LINK: 'External Link',
            INTERNAL_LINK_ARTICLE: 'Internal link to an existing article',
            INTERNAL_LINK_FILE: 'Internal link to an existing file',
            EDIT_IMAGE: 'Edit Image',
            ROTATE_LEFT: ' (rotate left) ',
            ROTATE_RIGHT: ' (rotate right) ',
            ZOOM_IN: ' (zoomIn) ',
            ZOOM_OUT: ' (zoomOut) ',
            FIT: ' (fit) ',
            CROP: ' [crop] ',
            APPLY_BRIGHTNESS: 'Edit Brightness',
            TEXT: 'Text',
            TABLE: 'Table',
            OPTION: 'Option',
            RESULTS: 'Results',
            PRIVACY_1: 'I accept',
            PRIVACY_2: 'the privacy policy.',
            PRIVACY_TITLE_COOKIES: 'Cookies',
            PRIVACY_BODY_COOKIES: 'Cookies sind Textdateien, die automatisch bei dem Aufruf einer Onlinepräsenz lokal im Browser des Besuchers abgelegt werden. Diese Website setzt Cookies ein, um das Angebot nutzerfreundlich und funktionaler zu machen. Dank dieser Dateien ist es beispielsweise möglich, dass Sie speziell auf Ihre Interessen abgestimmte Informationen auf der Seite angezeigt bekommen. Auch Sicherheitsrelevante Funktionen zum Schutz Ihrer Privatsphäre werden durch den Einsatz von Cookies ermöglicht. Der ausschließliche Zweck besteht also darin, unser Angebot Ihren Kundenwünschen bestmöglich anzupassen und Ihnen das Surfen bei uns so komfortabel wie möglich zu gestalten und die Navigation zu erleichtern. Diese Website folgt der Richtlinie (§96.Abs.3.TKG.06) zum Nutzerhinweis auf die Verwendung von Cookies und den Datenschutz.',
            PRIVACY_TITLE_ANALYTICS: 'Google Analytics',
            PRIVACY_BODY_ANALYTICS: 'Dieses Angebot nutzt ebenfalls den Webanalysedienst Google Analytics, ein Programm der Google Inc. (\\"Google, USA\\"). Die durch das Tracking erfassten Informationen zu Ihrer Nutzung dieser Website werden auf einem Server von Google in den USA gespeichert. Durch eine sogenannte IP-Anonymisierung wird Ihre IP-Adresse von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Somit ist der Standort Ihres Browsers lediglich regional zuortbar, nicht aber ihrer Person. Google kann Besucherverhalten auswerten, um Reports über die Websiteaktivitäten zusammenzustellen. Auch weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen können so gegenüber dem Websitebetreiber erbracht werden.'
        };
        return translations;
    }

    return {
        getLanguagePack
    };
}



// WEBPACK FOOTER //
// ./src/app/services/languagesFactory.js